import { useDispatch } from 'react-redux';

export default function useStoreCarPlan() {
    const dispatch = useDispatch();

    const executor = (car_plan) => {
        return dispatch({
            type: 'SET_CAR_PLAN',
            payload: car_plan,
        });
    };

    return executor;
};